import toast from "react-hot-toast";
import toastIcons, {
  CustomToastProps,
  toastColors,
  toastTitles,
  ToastTypeEnum,
} from "../../assets/utils/enums/toast";
import closeIcon from "../../assets/images/icons/close-white-icon.svg";
import closeIconDark from "../../assets/images/icons/close-dark-icon.svg";
import styled from "styled-components";
import { LittleHeadline, NotificationText } from "../typography";
import breakpoints from "../../assets/styles/breakpoint";
import { COLORS } from "../../assets/utils/enums/colors";

const CustomToast: React.FC<CustomToastProps> = ({
  t,
  type = ToastTypeEnum.DEFAULT,
  text,
}: CustomToastProps) => {
  return (
    <ToastStyle type={type}>
      <span className="d-flex align-items-start gap-2">
        <img src={toastIcons[type]} alt="toaster-icon" />
        <span className="d-flex flex-column gap-0.5">
          <LittleHeadline>{toastTitles[type]}</LittleHeadline>
          <NotificationText>{text}</NotificationText>
        </span>
      </span>
      <button onClick={() => toast.dismiss(t.id)} style={{ marginLeft: 8 }}>
        <img
          src={type === ToastTypeEnum.DEFAULT ? closeIconDark : closeIcon}
          alt="close-icon"
        />
      </button>
    </ToastStyle>
  );
};

export default CustomToast;

const ToastStyle = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "type",
})<{ type: ToastTypeEnum }>`
  margin: 0;
  padding: 8px;
  border-radius: 12px;
  width: 40%;
  display: flex;
  align-items: start;
  justify-content: space-between;
  box-shadow: 0 2px 2px 0 rgba(9, 21, 64, 0.25);
  background-color: ${({ type }) => toastColors[type]};
  ${LittleHeadline} {
    padding-bottom: 2px;
  }
  & > * {
    color: ${({ type }) =>
      type === ToastTypeEnum.DEFAULT ? COLORS.secondary1 : COLORS.white};
  }
  button {
    background-color: ${({ type }) => toastColors[type]};
    transition: background-color 0.3s ease;
    border: none;
    outline: none;
    padding: 4px;
    border-radius: 12px;

    &:hover {
      filter: brightness(0.93);
    }

    &:focus-within {
      outline: none;
    }
    img {
      height: 30px;
      width: 30px;
    }
  }

  @media (max-width: 1136px) {
    width: 50%;
  }

  ${breakpoints.lg} {
    width: 60%;
  }

  ${breakpoints.md} {
    width: 75%;
  }

  ${breakpoints.sm} {
    width: 85%;
  }

  ${breakpoints.sm} {
    width: 100%;
  }
`;
